import React from 'react';
import ReactDOM from 'react-dom';

// 모달 루트 DOM 요소를 가져옵니다. (index.html에 <div id="modal-root"></div> 필요)
const modalRoot = document.getElementById('modal-root');

/**
 * 프로젝트의 디자인 컨벤션에 맞춘 '준비 중입니다' 안내 모달 컴포넌트입니다.
 * @param {boolean} isOpen - 모달 표시 여부
 * @param {function} onClose - 모달을 닫는 함수
 * @param {string} title - 모달의 제목 (선택 사항, 기본값: '알림')
 * @param {string} message - 모달의 본문 메시지 (선택 사항, 기본값: '서비스 준비 중입니다.')
 */
function NotYetModal({ isOpen, onClose, title = "알림", message = "서비스 준비 중입니다." }) {

    if (!isOpen) {
        return null;
    }

    // 포탈을 사용하여 모달 렌더링
    return ReactDOM.createPortal(
        <div style={staticStyles.modalOverlay} onClick={onClose}>
            <div style={staticStyles.modalContent} onClick={(e) => e.stopPropagation()}>
                <h3 style={staticStyles.modalTitle}>{title}</h3>
                <p style={staticStyles.modalText}>{message}</p>
                <button
                    style={staticStyles.confirmButton}
                    onClick={onClose}
                >
                    확인
                </button>
            </div>
        </div>,
        modalRoot
    );
}

/** @type {React.CSSProperties} */
const staticStyles = {
    // --- 모달 공통 스타일 (ConfirmModal.jsx, ErrorModal과 유사하게) ---
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        // 어두운 배경색: rgba(13, 4, 45, 0.9) - Home.jsx의 QR 모달 배경색 참고
        backgroundColor: 'rgba(13, 4, 45, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1150, // BottomSheet(1100) 보다 높고 QR Modal(1200)보다 낮게 설정
        backdropFilter: 'blur(5px)',
    },
    modalContent: {
        background: '#1B1931', // 배경색
        padding: '30px 24px 24px',
        borderRadius: '12px',
        width: 'calc(100% - 80px)',
        maxWidth: '350px',
        boxSizing: 'border-box',
        textAlign: 'center',
        border: '1px solid #3A394A',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    modalTitle: {
        fontFamily: 'Pretendard',
        fontSize: '20px',
        fontWeight: '700',
        color: '#FCFCFA',
        margin: 0,
    },
    modalText: {
        fontFamily: 'Pretendard',
        fontSize: '15px',
        fontWeight: '500',
        color: '#C0C0C0',
        margin: 0,
        lineHeight: '1.5',
        withSpace: 'pre-line',
    },
    // --- 확인 버튼 스타일 (Login.jsx, Home.jsx의 그라데이션 버튼 참고) ---
    confirmButton: {
        width: '100%',
        height: '48px',
        // 보라색-파란색 그라데이션
        background: 'linear-gradient(90deg, #8052FF 0%, #0231FB 100%)',
        border: 'none',
        borderRadius: '6px',
        color: '#FFFFFF',
        fontFamily: 'Pretendard',
        fontSize: '16px',
        fontWeight: '700',
        cursor: 'pointer',
        marginTop: '10px',
    },
};

export default NotYetModal;